import * as L from 'leaflet';

// TH: Longterm, it'd be great to make these an enum. But in the meantime...
export const ZONE_TYPE_CIRCLE = 'circle';
export const ZONE_TYPE_POLYGON = 'polygon';

export type LocationCoords = PolygonCoords | CircleCoords | null;

export class CircleCoords {
    // NOTE: radius in meters
    constructor(public latLong : LatLong, public radius : number) { }

    toString() {
        // compact format for DB storage
        return this.latLong.toString('C') + '~' + this.radius.toFixed(5);
    }

    static fromLeaflet(circle : L.Circle) {
        return new CircleCoords(LatLong.fromLeaflet(circle.getLatLng()), circle.getRadius());
    }

    toLeaflet(options? : L.CircleMarkerOptions) {
        return L.circle(LatLong.toLeaflet(this.latLong), this.radius, options);
    }
}

export class PolygonCoords {
    constructor(public coords : LatLong[]) { }

    toString() {
        // compact format for DB storage
        return this.coords.map(latLong => latLong.toString('C')).join('~');
    }

    static fromLeaflet(polygon : L.Polygon) {
        return new PolygonCoords(polygon.getLatLngs().map(LatLong.fromLeaflet));
    }

    toLeaflet(options? : L.PolylineOptions) {
        return L.polygon(this.coords.map(LatLong.toLeaflet), options);
    }
}

export class LatLong {
    constructor(public lat : number, public long : number) { }

    toString() : string;
    toString(specifier : 'P' | 'C') : string; // 'P' = pretty; 'C' = compact
    toString(specifier : 'P' | 'C' = 'P') {
        if (specifier === 'P') {
            // pretty format for display
            const northSouth = this.lat >= 0 ? 'N' : 'S',
                eastWest = this.long >= 0 ? 'E' : 'W';

            // \u00B0 = degree symbol
            return `${Math.abs(this.lat)}\u00B0 ${northSouth}, ${Math.abs(this.long)}\u00B0 ${eastWest}`;
        }
        if (specifier === 'C') {
            // compact format for DB storage
            return this.lat.toFixed(5) + ',' + this.long.toFixed(5);
        }
        throw new Error('Unknown format specifier ' + specifier);
    }

    // Parse string formatted as '{latitude},{longitude}', e.g. '-28,-62'
    static parse(latLong : string) {
        const split = latLong.split(','),
            lat = +split[0],
            long = +split[1];
        if (isNaN(lat) || isNaN(long)) throw new Error('Unparseable lat/long string ' + latLong);
        return new LatLong(lat, long);
    }

    static fromLeaflet(latLong : L.LatLng) {
        return new LatLong(latLong.lat, latLong.lng);
    }

    static toLeaflet(latLong : LatLong) {
        return L.latLng(latLong.lat, latLong.long);
    }
}

// Parse from DB storage
export function parseZoneCoordinates(zoneCoords : string | null, zoneType : string | null) : LocationCoords {
    if (!zoneCoords) return null;
    const coords = zoneCoords.split('~');
    if (zoneType === ZONE_TYPE_CIRCLE) {
        const radius = +coords[1];
        if (isNaN(radius)) throw new Error('Unparsedable zone coordinates: ' + zoneCoords);
        return new CircleCoords(LatLong.parse(coords[0]), radius);
    } else if (zoneType === ZONE_TYPE_POLYGON) {
        return new PolygonCoords(coords.map(LatLong.parse));
    } else {
        throw new Error('Unrecognized ZoneType: ' + zoneType);
    }
}


// WEBPACK FOOTER //
// ./data/models/ZoneCoordinates.ts